import myhub from './myhub.json';
import alerts from './alerts.json';
import sso from './sso.json';
import leftmenu from './leftmenu.json';
import settings from './settings.json';
import myapps from './myapps.json';
import helpPanel from './help-panel.json';
import licencePopups from './licence-popups.json';

export const ptBR = {
  myhub,
  alerts,
  sso,
  leftmenu,
  settings,
  myapps,
  helpPanel,
  licencePopups,
};
